import React from "react";
import { Route, Routes } from "react-router-dom";
import { SimpleLayout } from "../components/simpleLayout";

// ROTAS
import { PoliticaPrivacidadeConfirmacaoLogin } from "../pages/politicaPrivacidade/confirmacaoLogin";

const PoliticaRoutes = () => {
  return (
    <SimpleLayout>
      <Routes>
        <Route path="*" element={<PoliticaPrivacidadeConfirmacaoLogin />} />
      </Routes>
    </SimpleLayout>
  );
};

export { PoliticaRoutes };
